<template>
  <div>
    <h2>Animal Numbers</h2>

    <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

      <div class="row">
        <div class="last_year_totals farm-fields" :class="{is_fonterra_client: isFonterraClient}">
          <h3>Last Year Total</h3>

          <div class="form-group input-box">
            <label>Total Cows Wintered incl R2 </label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').cows_wintered_incl_r2" disabled>
          </div>

          <div class="form-group input-box">
            <label>R2</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').r2" disabled>
          </div>

          <div class="form-group input-box">
            <label>R1</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').r1" disabled>
          </div>
        </div>

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">

            <number-input label="Total Cows Wintered incl R2"
                          field-name="cows_wintered_incl_r2"
                          :farm-id="farm.id"
                          @on-change="checkAndCompleteStep"
                          required
                          :min="1"
                          :disabled="isReadOnly">
            </number-input>

            <number-input label="R2"
                          :field-name="`farm_${farm.id}-r2`"
                          :disabled="isReadOnly">
            </number-input>

            <number-input label="R1"
                          :field-name="`farm_${farm.id}-r1`"
                          :disabled="isReadOnly">
            </number-input>
          </div> <!-- end fonterra div -->
        </div>
      </div>

      <div class="row">
        <div class="last_year_totals farm-fields" :class="{is_fonterra_client: isFonterraClient}">
          <div class="form-group input-box">
            <label>PM Cows confirmed (Nov)</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').cows_pm_confirmed_nov" disabled>
          </div>

          <div class="form-group input-box">
            <label>Bulls</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').bulls" disabled>
          </div>

          <div class="form-group input-box">
            <label>Beef</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').beef" disabled>
          </div>

        </div>

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id" :class="{is_fonterra_client: isFonterraClient}">

          <number-input label="PM Cows Pred."
                        :field-name="`farm_${farm.id}-cows_pm_predicted`"
                        :disabled="isReadOnly">
          </number-input>

          <number-input label="Bulls"
                        :field-name="`farm_${farm.id}-bulls`"
                        :disabled="isReadOnly">
          </number-input>

          <number-input label="Beef"
                        :field-name="`farm_${farm.id}-beef`"
                        :disabled="isReadOnly">
          </number-input>

          <span v-show="errors.has(`farm_${farm.id}-breed_error`)" class="text-danger">
            {{ errors.first(`farm_${farm.id}-breed_error`) }}
          </span>


        </div>
      </div>

      <div class="row">
        <div class="last_year_totals farm-fields" :class="{is_fonterra_client: isFonterraClient}">
          <div class="form-group input-box">
            <label>Cow Deaths</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').cow_deaths" disabled>
          </div>

          <div class="form-group last_year_culls input-box" :class="{is_fonterra_client: isFonterraClient}">
            <label>Culls</label>
            <input type="text" class="form-control" :value="getFieldValue('AGGREGATED_TOTALS').cow_culls" disabled>
          </div>
        </div>

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id" :class="{is_fonterra_client: isFonterraClient}">

          <div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">
            <number-input label="Cow Deaths"
                          :field-name="`farm_${farm.id}-cow_deaths`"
                          :add-comment="true"
                          :disabled="isReadOnly">
            </number-input>

            <div class="form-group">
              <label>Mortality rate this season</label>
              <input type="text" class="form-control" :value="mortalityRateThisSeason(farm.id)" disabled>
            </div>

            <text-input label="Goal for next season (%)"
                          :field-name="`farm_${farm.id}-cd_mortality_rate_goal`"
                          :disabled="isReadOnly">
            </text-input>

            <div class="form-group">
              <label>Plan for mortality rate/cow deaths</label>
              <comments :field-name="`farm_${farm.id}-bcs_mortality_rate_plan`" :isReadOnly="isReadOnly"></comments>
            </div>
          </div>

          <number-input label="Culls"
                        :field-name="`farm_${farm.id}-cow_culls`"
                        :add-comment="true"
                        :disabled="isReadOnly">
          </number-input>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AnimalNumbers',
  mixins: [ baseComponent ],
  methods: {
    ...mapMutations('currentConsult', ['completeStep',]),
    ...mapGetters('currentConsult', ['isFonterraFarm']),
    validate: function ()
    {
      return this.getFieldValue('FARMS', this.$options.name).every(farm => {
        return this.hasAnimalNumbersFor(farm)
        // return [0, 100].includes(this.breedPercentFor(farm)) && this.hasAnimalNumbersFor(farm)
      })
    },
    mortalityRateThisSeason: function (farm_id)
    {
      let farmMortalityPrevious  = ((this.getFieldValue('PREVIOUS_YEAR', this.$options.name) || {} )[farm_id] || {}).cows_wintered_incl_r2
      let canShowMortalityRate = (this.getFieldValue('farm_'+farm_id+'-cow_deaths') && farmMortalityPrevious)
      return (canShowMortalityRate)
        ? ((this.getFieldValue('farm_'+farm_id+'-cow_deaths') / farmMortalityPrevious) * 100).toFixed(2) + '%'
        : ''
    },
    breedPercentFor: function (farm)
    {
      return  this.getFieldValue(`farm_${farm.id}-other_percent`, this.$options.name) +
        this.getFieldValue(`farm_${farm.id}-cross_breed_percent`, this.$options.name) +
        this.getFieldValue(`farm_${farm.id}-jersey_percent`, this.$options.name) +
        this.getFieldValue(`farm_${farm.id}-friesian_percent`, this.$options.name);
    },
    validateBreed: function(farm){
      let farmId = farm.id
      let total = this.breedPercentFor(farm)

      if (total != 100) {
        this.errors.remove(`farm_${farmId}-breed_error`)
        this.errors.add({
          field: `farm_${farmId}-breed_error`,
          msg: `Sum of breed percentages needs to add to 100. Current Value ${total}`
        })
      } else {
        this.errors.remove(`farm_${farmId}-breed_error`)
      }
      return (total > 0) ? total == 100 : true
    },
    hasAnimalNumbersFor: function (farm)
    {
      let fieldsToCheck = ['cows_wintered_incl_r2',]

      return fieldsToCheck.map(field => `farm_${farm.id}-${field}`)
        .reduce((sum, field) => sum + (parseInt(this.getFieldValue(field, 'AnimalNumbers')) || 0), 0) > 0
    }
  },
  computed: {
    ...mapGetters('currentConsult', [ 'isFonterraClient', ]),
    has_breed_error: function() {
      return this.errors.items.filter(error => error.field.endsWith('breed_error')).length > 0
    },
  },
};
</script>

<style>
.farm-fields {
  float: left;
  width: 350px;
  margin-right: 3em;
}
.is_fonterra_client {
  padding-top: 42px;
}

.last_year_culls {
  margin-top: 202px;
}
.last_year_culls.is_fonterra_client {
  margin-top: 227px;
}
</style>

